import Request from '@hotmart/request';

class TosService {
  fetchUnleashTosToggles = () => {
    return Request('tos.features')
      .then((response) => {
        return {
          canUseTOSApiV2: response.ALLOW_USE_API_TOS_V2
        };
      })
      .catch(() => {
        return { canUseTOSApiV2: false };
      });
  };
}

export default new TosService();
